<template>
	<div>
        <div v-for="user in value">
            <span class="img-member-avatar" :style="`background-image: url('${user.photo_url}')`"></span>
            {{ user.name}}
        </div>
	</div>
</template>
<style>
    .img-member-avatar {
        display: inline-block;
        background-size: cover;
        width: 32px;
        height: 32px;
        background-position: center center;
        margin-right: 4px;
        border-radius: 50% !important;
    }
</style>
<script>
export default {
    props: ['value']
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/table/value/Users.vue